import { setErrorStatus } from "../Redux/status/action";

export async function getSummaryCount({ accessToken, collection, subCollection, uniqueKey, query, type }) {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/summary`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth-token": `Bearer ${accessToken}`
    },
    body: JSON.stringify({
      ...(collection ? { collection } : {}),
      ...(subCollection ? { subCollection } : {}),
      ...(uniqueKey ? { uniqueKey } : {}),
      query,
      type
    })
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    console.error(errorMessage);
    throw new Error("Error while fetching summary");
  }

  const result = await response.json();
  return result.data;
}

export async function getComplaintsSummaryCountApi(filters, accessToken) {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/summary`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth-token": `Bearer ${accessToken}`
    },
    body: JSON.stringify({
      collection: "complaints",
      type: "count",
      query: { data: filters }
    })
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    console.error(errorMessage);
    throw new Error("Error while fetching complaints count");
  }

  const result = await response.json();
  return result.data;
}

export function reportError(error) {
  setErrorStatus(error);
}
